import { InputParametersHierarchyId, InputParametersHierarchyLevel } from '../../../models/InputParametersHierarchy'
import { InputParameterHierarchyType } from '../../../components/InputParameterHierarchy/model'
import { InputParametersHierarchyContext } from '../../../store/ai/inputParametersHierarchy'

export const ZOCKS_SYSTEM_USER_ID = 'zocks-system-usr'

export const calculateLevel = (type: InputParameterHierarchyType, context: InputParametersHierarchyContext): InputParametersHierarchyLevel => {
  return type == InputParameterHierarchyType.DOCUMENT_SUMMARY_TEMPLATE
    ? context.userId && context.documentTypeId
      ? InputParametersHierarchyLevel.DOCUMENT_TYPE_USER
      : context.userId
        ? InputParametersHierarchyLevel.USER
        : context.documentTypeId
          ? InputParametersHierarchyLevel.DOCUMENT_TYPE_GLOBAL
          : InputParametersHierarchyLevel.GLOBAL
    : type == InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE || type == InputParameterHierarchyType.NEW_EMAIL_TEMPLATE
      ? context.userId && context.emailTypeId
        ? InputParametersHierarchyLevel.EMAIL_TYPE_USER
        : context.userId
          ? InputParametersHierarchyLevel.USER
          : context.emailTypeId
            ? InputParametersHierarchyLevel.EMAIL_TYPE_GLOBAL
            : InputParametersHierarchyLevel.GLOBAL
      : context.userId && context.meetingTemplateId
        ? InputParametersHierarchyLevel.MEETING_TEMPLATE_USER
        : context.userId
          ? InputParametersHierarchyLevel.USER
          : context.meetingTemplateId
            ? InputParametersHierarchyLevel.MEETING_TEMPLATE_GLOBAL
            : InputParametersHierarchyLevel.GLOBAL
}

export const calculateHierarchyId = (type: InputParameterHierarchyType, context: InputParametersHierarchyContext): InputParametersHierarchyId => {
  const calculatedLevel = calculateLevel(type, context)
  return (
    type == InputParameterHierarchyType.DOCUMENT_SUMMARY_TEMPLATE
      ? { level: calculatedLevel, userId: context.userId, documentTypeId: context.documentTypeId }
      : type == InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE || type == InputParameterHierarchyType.NEW_EMAIL_TEMPLATE
        ? { level: calculatedLevel, userId: context.userId, emailTypeId: context.emailTypeId }
        : { level: calculatedLevel, userId: context.userId, meetingTemplateId: context.meetingTemplateId }
  ) as InputParametersHierarchyId
}
